'use client';

import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { TRENDING_VIDEO_QUERIES } from '../../infrastructure/trendingVideo/utils/queries';
import type { ListTrendingVideosRequest } from '../../infrastructure/trendingVideo/utils/types';

export const useTrendingVideoService = () => {
  const useListTrendingVideosQuery = (params?: ListTrendingVideosRequest) => {
    return useQuery(TRENDING_VIDEO_QUERIES.list({ visibleOnly: true, ...params }));
  };

  const useListTrendingVideosSuspenseQuery = (params?: ListTrendingVideosRequest) => {
    return useSuspenseQuery(TRENDING_VIDEO_QUERIES.list({ visibleOnly: true, ...params }));
  };

  const useGetTrendingVideoQuery = (videoId: string) => {
    return useQuery(TRENDING_VIDEO_QUERIES.detail(videoId));
  };

  return {
    useListTrendingVideosQuery,
    useListTrendingVideosSuspenseQuery,
    useGetTrendingVideoQuery,
  };
};
